import { Navigate, useNavigate } from 'react-router-dom';
import { useProfile } from '../hooks/index';
import { useEffect } from 'react';
import { redirectEmitter } from '../api/apiCore';

const AuthProtected = (props: any) => {
    const navigate = useNavigate();
    const { userProfile, loading } = useProfile();
    useEffect(() => {
        const handleUnauthorized = () => {
            navigate('/logout');
        };
        redirectEmitter.on('unauthorized', handleUnauthorized);
        return () => {
            redirectEmitter.off('unauthorized', handleUnauthorized);
        };
    }, [navigate]);

    if (!userProfile && loading) {
        return <Navigate to={{ pathname: '/auth-login' }} />;
    }

    return <>{props.children}</>;
};

export { AuthProtected };
